/**
 * Extract a human-readable error message from an axios error.
 * FastAPI returns 422 with detail = array of {type, loc, msg, input, url} objects,
 * which crash React when passed as a child. This util always returns a string.
 */
export function apiError(e, fallback = "Something went wrong") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first && typeof first === "object") {
      const loc = Array.isArray(first.loc) ? first.loc.join(".") : "";
      return `${loc ? loc + ": " : ""}${first.msg || fallback}`;
    }
    return detail.map((d) => (typeof d === "string" ? d : d?.msg)).filter(Boolean).join(", ") || fallback;
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message) return detail.message;
    if (typeof detail.msg === "string" && detail.msg) return detail.msg;
    return fallback;
  }
  return e?.message || fallback;
}
